/** @jsxImportSource @emotion/react */
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import EditNoteIcon from "@mui/icons-material/EditNote";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Chip } from "@mui/material";
import { VFC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { CountryPath } from "src/entities/CountryPath";

interface Props {
  country: CountryPath;
}

const SelectGenerationMethodPage: VFC<Props> = (props: Props) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const goManual = () => {
    navigate(`/article/new/manual?country=${props.country}`);
  };

  const goAi = () => {
    navigate(`/article/new/ai?country=${props.country}`);
  };

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-12">
      <h1 className="mb-10 text-center text-xl font-bold text-gray-800 sm:text-2xl">
        {t("create_press_release.select_method.title")}
      </h1>
      <div className="grid w-full max-w-3xl grid-cols-1 gap-6 sm:grid-cols-2">
        {/* Manual card */}
        <button
          type="button"
          onClick={goManual}
          className="flex flex-col items-start rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm transition hover:border-primary hover:shadow-md"
        >
          <EditNoteIcon className="mb-4 text-primary" style={{ fontSize: 40 }} />
          <div className="mb-2 text-lg font-bold text-gray-800">
            {t("create_press_release.select_method.manual.title")}
          </div>
          <div className="text-sm text-gray-500">
            {t("create_press_release.select_method.manual.desc")}
          </div>
        </button>

        {/* AI card */}
        <button
          type="button"
          onClick={goAi}
          className="relative flex flex-col items-start rounded-xl border border-gray-200 bg-white p-6 text-left shadow-sm transition hover:border-primary hover:shadow-md"
        >
          <Chip
            label={t("create_press_release.select_method.ai.beta")}
            size="small"
            color="primary"
            className="!absolute !right-4 !top-4"
          />
          <AutoAwesomeIcon
            className="mb-4 text-primary"
            style={{ fontSize: 40 }}
          />
          <div className="mb-2 text-lg font-bold text-gray-800">
            {t("create_press_release.select_method.ai.title")}
          </div>
          <div className="text-sm text-gray-500">
            {t("create_press_release.select_method.ai.desc")}
          </div>
        </button>
      </div>

      {/* AI language note */}
      <div className="mt-6 flex max-w-3xl items-start gap-2 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-xs text-gray-600">
        <InfoOutlinedIcon className="mt-0.5 text-primary" fontSize="small" />
        <span>{t("create_press_release.select_method.ai.language_note")}</span>
      </div>
    </div>
  );
};

export default SelectGenerationMethodPage;
